import { readRawCookies, writeClientCookie } from '@/composables/useCookie';
import { COOKIE_KEY } from '@/constant';

export function writeExpires() {
  const token = readRawCookies()?.[COOKIE_KEY.TOKEN] as string;
  const access_token = readRawCookies()?.[COOKIE_KEY.ACCESS_TOKEN] as string;
  const refresh_token = readRawCookies()?.[COOKIE_KEY.REFRESH_TOKEN] as string;
  if (!token && !access_token && !refresh_token) return;

  const TEN_MINUTES = 600000;
  const expires = new Date(Date.now() + TEN_MINUTES);
  writeClientCookie(COOKIE_KEY.EXPIRED, +expires, {
    expires,
  });
}

export function readExpires() {
  const expired = readRawCookies()?.[COOKIE_KEY.EXPIRED] as number;
  return expired;
}

export function writeToken(token: string, expires?: Date) {
  writeClientCookie(
    COOKIE_KEY.TOKEN,
    token,
    expires
      ? {
          expires,
        }
      : undefined
  );

  writeExpires();
}

export function readToken() {
  const token = readRawCookies()?.[COOKIE_KEY.TOKEN] as string;
  return token;
}

export function writeAccessToken(accessToken: string, expires?: Date) {
  writeClientCookie(
    COOKIE_KEY.ACCESS_TOKEN,
    accessToken,
    expires
      ? {
          expires,
        }
      : undefined
  );
  writeExpires();
}

export function readAccessToken() {
  const token = readRawCookies()?.[COOKIE_KEY.ACCESS_TOKEN] as string;
  return token;
}

export function writeRefreshToken(refreshToken: string, expires?: Date) {
  writeClientCookie(
    COOKIE_KEY.REFRESH_TOKEN,
    refreshToken,
    expires
      ? {
          expires,
        }
      : undefined
  );
  writeExpires();
}

export function readRefreshToken() {
  const token = readRawCookies()?.[COOKIE_KEY.REFRESH_TOKEN] as string;
  return token;
}

export function writeRefreshExpires(refreshExpires: Date) {
  const expires = new Date(refreshExpires);
  writeClientCookie(COOKIE_KEY.REFRESH_EXPIRED, expires, {
    expires,
  });
}

export function readRefreshExpires() {
  const expired = readRawCookies()?.[COOKIE_KEY.REFRESH_EXPIRED] as number;
  return expired;
}
